import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/material-requests'
    {path: '', pathMatch : 'full', redirectTo: 'material-requests'},

    // Redirect signed-in user to the '/material-requests'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'material-requests'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [

        {
            path: 'offers',
            loadChildren: () => import('app/modules/admin/product-brand-table/product-brand.routes')
          },
          {
            path: 'submitquote',
            loadChildren: () => import('app/modules/admin/product-brand-table-split/product-brand-table-split.routes')
          },
          {
            path: 'submitquote-v2',
            loadChildren: () => import('app/modules/admin/product-brand-table-split-discount/product-brand-table-split-discount.routes')
          },
          {
            path: 'material-requests',
            loadChildren: () => import('app/modules/material-requests/material-requests.routing').then(m => m.materialRequestsRoutes)
          },
          {
            path: 'super-stock-list',
            loadChildren: () => import('app/modules/super-stock-list/super-stock-list.routing').then(m => m.superStockListRoutes)
          },
          {
            path: 'super-stockist-admin',
            loadChildren: () => import('app/modules/super-stockist-admin/super-stockist-admin.routing').then(m => m.superStockistAdminRoutes)
          },
          {
            path: 'purchase-orders',
            loadComponent: () => import('app/modules/purchase-orders/purchase-orders.component').then(m => m.PurchaseOrdersComponent)
          }
        ]
    }
];
